import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { dataService } from '../services/dataService';
import { Clock, AlertTriangle, Mail, CreditCard, ArrowRight } from 'lucide-react';

interface TrialExpiredModalProps {
  onClose?: () => void;
}

const TrialExpiredModal: React.FC<TrialExpiredModalProps> = ({ onClose }) => {
  const { tenantData, logout } = useAuth();

  const handleContactSupport = () => {
    window.open('mailto:support@cafelawn.com?subject=Trial Expired - Need Help', '_blank');
  };

  const handleUpgrade = () => {
    // Navigate to subscription page
    window.location.href = '/subscription';
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6 text-center">
        <div className="w-16 h-16 mx-auto mb-4 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
          <Clock className="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>
        
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Trial Period Expired
        </h2>
        
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Your free trial has ended. To continue using CafeLawn, please upgrade to a paid plan or contact our support team.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleUpgrade}
            className="w-full btn btn-primary flex items-center justify-center gap-2 py-3"
          >
            <CreditCard className="w-4 h-4" />
            Upgrade to Paid Plan
            <ArrowRight className="w-4 h-4" />
          </button>
          
          <button
            onClick={handleContactSupport}
            className="w-full btn btn-secondary flex items-center justify-center gap-2 py-3"
          >
            <Mail className="w-4 h-4" />
            Contact Support
          </button>
          
          <button
            onClick={handleLogout}
            className="w-full text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 py-2"
          >
            Logout
          </button>
        </div>

        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          >
            <AlertTriangle className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TrialExpiredModal; 